export const pointPM2_5 = {
    id: "78mmbl",
    type: "point",
    config: {
        dataId: "pm2_5",
        label: "PM 2.5",
        color: [119, 119, 119],
        highlightColor: [252, 242, 26, 255],
        columns: {
            lat: "lat",
            lng: "lon",
            altitude: null,
        },
        isVisible: true,
        visConfig: {
            radius: 20,
            fixedRadius: false,
            opacity: 0,
            outline: false,
            thickness: 2,
            strokeColor: null,
            colorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#5A1846",
                    "#900C3F",
                    "#C70039",
                    "#E3611C",
                    "#F1920E",
                    "#FFC300",
                ],
            },
            strokeColorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#5A1846",
                    "#900C3F",
                    "#C70039",
                    "#E3611C",
                    "#F1920E",
                    "#FFC300",
                ],
            },
            radiusRange: [0, 50],
            filled: true,
        },
        hidden: false,
        textLabel: [
            {
                field: null,
                color: [255, 255, 255],
                size: 18,
                offset: [0, 0],
                anchor: "start",
                alignment: "center",
            },
        ],
    },
}


export const pointPM2_5Heatmap = {
    id: "78mmbl",
    type: "point",
    config: {
        dataId: "pm2_5",
        label: "PM 2.5",
        color: [179, 173, 158],
        highlightColor: [252, 242, 26, 255],
        columns: {
            lat: "lat",
            lng: "lon",
            altitude: null,
        },
        isVisible: true,
        visConfig: {
            radius: 10,
            fixedRadius: false,
            opacity: 0.8,
            outline: false,
            thickness: 2,
            strokeColor: null,
            colorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#EDD1CA",
                    "#C99DA4",
                    "#A6758E",
                    "#83537C",
                    "#573660",
                    "#2C1E3D"
                ],
            },
            strokeColorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#EDD1CA",
                    "#C99DA4",
                    "#A6758E",
                    "#83537C",
                    "#573660",
                    "#2C1E3D"
                ],
            },
            radiusRange: [0, 50],
            filled: true,
        },
        hidden: false,
        textLabel: [
            {
                field: null,
                color: [255, 255, 255],
                size: 18,
                offset: [0, 0],
                anchor: "start",
                alignment: "center",
            },
        ],
        colorField: {
            name: "data_norm",
            type: "real",
        },
        colorScale: "quantize",
        strokeColorField: null,
        strokeColorScale: "quantize",
        sizeField: null,
        sizeScale: "linear",

    },

    visualChannels: {
        colorField: {
            name: "data_norm",
            type: "real",
        },
        colorScale: "quantize",
        strokeColorField: null,
        strokeColorScale: "quantize",
        sizeField: null,
        sizeScale: "linear",
    },
}

export const getPointPM2_5Heatmap = (opacity=0.8)=>{
    return {
        id: "78mmbl",
        type: "point",
        config: {
            dataId: "pm2_5",
            label: "PM 2.5",
            color: [179, 173, 158],
            highlightColor: [252, 242, 26, 255],
            columns: {
                lat: "lat",
                lng: "lon",
                altitude: null,
            },
            isVisible: true,
            visConfig: {
                radius: 10,
                fixedRadius: false,
                opacity: opacity,
                outline: false,
                thickness: 2,
                strokeColor: null,
                colorRange: {
                    name: "Global Warming",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#EDD1CA",
                        "#C99DA4",
                        "#A6758E",
                        "#83537C",
                        "#573660",
                        "#2C1E3D"
                    ],
                },
                strokeColorRange: {
                    name: "Global Warming",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#EDD1CA",
                        "#C99DA4",
                        "#A6758E",
                        "#83537C",
                        "#573660",
                        "#2C1E3D"
                    ],
                },
                radiusRange: [0, 50],
                filled: true,
            },
            hidden: false,
            textLabel: [
                {
                    field: null,
                    color: [255, 255, 255],
                    size: 18,
                    offset: [0, 0],
                    anchor: "start",
                    alignment: "center",
                },
            ],
            colorField: {
                name: "data_norm",
                type: "real",
            },
            colorScale: "quantize",
            strokeColorField: null,
            strokeColorScale: "quantize",
            sizeField: null,
            sizeScale: "linear",
    
        },
    
        visualChannels: {
            colorField: {
                name: "data_norm",
                type: "real",
            },
            colorScale: "quantize",
            strokeColorField: null,
            strokeColorScale: "quantize",
            sizeField: null,
            sizeScale: "linear",
        },
    }
}

export const pointPM10 = {
    id: "78mmbl",
    type: "point",
    config: {
        dataId: "pm10",
        label: "PM 10",
        color: [119, 119, 119],
        highlightColor: [252, 242, 26, 255],
        columns: {
            lat: "lat",
            lng: "lon",
            altitude: null,
        },
        isVisible: true,
        visConfig: {
            radius: 20,
            fixedRadius: false,
            opacity: 0,
            outline: false,
            thickness: 2,
            strokeColor: null,
            colorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#5A1846",
                    "#900C3F",
                    "#C70039",
                    "#E3611C",
                    "#F1920E",
                    "#FFC300",
                ],
            },
            strokeColorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#5A1846",
                    "#900C3F",
                    "#C70039",
                    "#E3611C",
                    "#F1920E",
                    "#FFC300",
                ],
            },
            radiusRange: [0, 50],
            filled: true,
        },
        hidden: false,
        textLabel: [
            {
                field: null,
                color: [255, 255, 255],
                size: 18,
                offset: [0, 0],
                anchor: "start",
                alignment: "center",
            },
        ],
    },
};

export const pointPM10Heatmap = {
    id: "78mmbl",
    type: "point",
    config: {
        dataId: "pm10",
        label: "PM 10",
        color: [179, 173, 158],
        highlightColor: [252, 242, 26, 255],
        columns: {
            lat: "lat",
            lng: "lon",
            altitude: null,
        },
        isVisible: true,
        visConfig: {
            radius: 10,
            fixedRadius: false,
            opacity: 0.8,
            outline: false,
            thickness: 2,
            strokeColor: null,
            colorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#EDD1CA",
                    "#C99DA4",
                    "#A6758E",
                    "#83537C",
                    "#573660",
                    "#2C1E3D"
                ],
            },
            strokeColorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#EDD1CA",
                    "#C99DA4",
                    "#A6758E",
                    "#83537C",
                    "#573660",
                    "#2C1E3D"
                ],
            },
            radiusRange: [0, 50],
            filled: true,
        },
        hidden: false,
        textLabel: [
            {
                field: null,
                color: [255, 255, 255],
                size: 18,
                offset: [0, 0],
                anchor: "start",
                alignment: "center",
            },
        ],
        colorField: {
            name: "data_norm",
            type: "real",
        },
        colorScale: "quantize",
        strokeColorField: null,
        strokeColorScale: "quantize",
        sizeField: null,
        sizeScale: "linear",

    },

    visualChannels: {
        colorField: {
            name: "data_norm",
            type: "real",
        },
        colorScale: "quantize",
        strokeColorField: null,
        strokeColorScale: "quantize",
        sizeField: null,
        sizeScale: "linear",
    },
}

export const getPointPM10Heatmap = (opacity = 0.8) => {
    return {
        id: "78mmbl",
        type: "point",
        config: {
            dataId: "pm10",
            label: "PM 10",
            color: [179, 173, 158],
            highlightColor: [252, 242, 26, 255],
            columns: {
                lat: "lat",
                lng: "lon",
                altitude: null,
            },
            isVisible: true,
            visConfig: {
                radius: 10,
                fixedRadius: false,
                opacity: opacity,
                outline: false,
                thickness: 2,
                strokeColor: null,
                colorRange: {
                    name: "Global Warming",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#EDD1CA",
                        "#C99DA4",
                        "#A6758E",
                        "#83537C",
                        "#573660",
                        "#2C1E3D"
                    ],
                },
                strokeColorRange: {
                    name: "Global Warming",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#EDD1CA",
                        "#C99DA4",
                        "#A6758E",
                        "#83537C",
                        "#573660",
                        "#2C1E3D"
                    ],
                },
                radiusRange: [0, 50],
                filled: true,
            },
            hidden: false,
            textLabel: [
                {
                    field: null,
                    color: [255, 255, 255],
                    size: 18,
                    offset: [0, 0],
                    anchor: "start",
                    alignment: "center",
                },
            ],
            colorField: {
                name: "data_norm",
                type: "real",
            },
            colorScale: "quantize",
            strokeColorField: null,
            strokeColorScale: "quantize",
            sizeField: null,
            sizeScale: "linear",

        },

        visualChannels: {
            colorField: {
                name: "data_norm",
                type: "real",
            },
            colorScale: "quantize",
            strokeColorField: null,
            strokeColorScale: "quantize",
            sizeField: null,
            sizeScale: "linear",
        },
    }
}

export const pointCO2 = {
    id: "7uz99hg",
    type: "point",
    config: {
        dataId: "CO2",
        label: "CO2",
        color: [117, 222, 227],
        highlightColor: [252, 242, 26, 255],
        columns: {
            lat: "lat",
            lng: "lon",
            altitude: null,
        },
        isVisible: true,
        visConfig: {
            radius: 20,
            fixedRadius: false,
            opacity: 0,
            outline: false,
            thickness: 2,
            strokeColor: null,
            colorRange: {
                name: "Uber Viz Sequential 4",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#E6FAFA",
                    "#C1E5E6",
                    "#9DD0D4",
                    "#75BBC1",
                    "#4BA7AF",
                    "#00939C",
                ],
            },
            strokeColorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#5A1846",
                    "#900C3F",
                    "#C70039",
                    "#E3611C",
                    "#F1920E",
                    "#FFC300",
                ],
            },
            radiusRange: [0, 10],
            filled: true,
        },
        hidden: false,
        textLabel: [
            {
                field: null,
                color: [255, 255, 255],
                size: 18,
                offset: [0, 0],
                anchor: "start",
                alignment: "center",
            },
        ],
    },
    visualChannels: {
        colorField: null,
        colorScale: "quantile",
        strokeColorField: null,
        strokeColorScale: "quantile",
        sizeField: null,
        sizeScale: "linear",
    },
};

export const pointCO2Heatmap = {
    id: "7uz99hg",
    type: "point",
    config: {
        dataId: "CO2",
        label: "CO2",
        color: [231, 159, 213],
        highlightColor: [252, 242, 26, 255],
        columns: {
            lat: "lat",
            lng: "lon",
            altitude: null,
        },
        isVisible: true,
        visConfig: {
            radius: 10,
            fixedRadius: false,
            opacity: 0.8,
            outline: false,
            thickness: 2,
            strokeColor: null,
            colorRange: {
                name: "Uber Viz Sequential 4",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#f7f7f7",
                    "#d9d9d9",
                    "#bdbdbd",
                    "#969696",
                    "#636363",
                    "#252525",
                ],
            },
            strokeColorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#f7f7f7",
                    "#d9d9d9",
                    "#bdbdbd",
                    "#969696",
                    "#636363",
                    "#252525",
                ],
            },
            radiusRange: [0, 10],
            filled: true,
        },
        hidden: false,
        textLabel: [
            {
                field: null,
                color: [255, 255, 255],
                size: 18,
                offset: [0, 0],
                anchor: "start",
                alignment: "center",
            },
        ],
        colorField: {
            name: "data_norm",
            type: "real",
        },
        colorScale: "quantize",
        strokeColorField: null,
        strokeColorScale: "quantize",
        sizeField: null,
        sizeScale: "linear",

    },

    visualChannels: {
        colorField: {
            name: "data_norm",
            type: "real",
        },
        colorScale: "quantize",
        strokeColorField: null,
        strokeColorScale: "quantize",
        sizeField: null,
        sizeScale: "linear",
    },
};
export const getPointCO2Heatmap = (opacity = 0.8) => {
    return {
        id: "7uz99hg",
        type: "point",
        config: {
            dataId: "CO2",
            label: "CO2",
            color: [231, 159, 213],
            highlightColor: [252, 242, 26, 255],
            columns: {
                lat: "lat",
                lng: "lon",
                altitude: null,
            },
            isVisible: true,
            visConfig: {
                radius: 10,
                fixedRadius: false,
                opacity: opacity,
                outline: false,
                thickness: 2,
                strokeColor: null,
                colorRange: {
                    name: "Uber Viz Sequential 4",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#f7f7f7",
                        "#d9d9d9",
                        "#bdbdbd",
                        "#969696",
                        "#636363",
                        "#252525",
                    ],
                },
                strokeColorRange: {
                    name: "Global Warming",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#f7f7f7",
                        "#d9d9d9",
                        "#bdbdbd",
                        "#969696",
                        "#636363",
                        "#252525",
                    ],
                },
                radiusRange: [0, 10],
                filled: true,
            },
            hidden: false,
            textLabel: [
                {
                    field: null,
                    color: [255, 255, 255],
                    size: 18,
                    offset: [0, 0],
                    anchor: "start",
                    alignment: "center",
                },
            ],
            colorField: {
                name: "data_norm",
                type: "real",
            },
            colorScale: "quantize",
            strokeColorField: null,
            strokeColorScale: "quantize",
            sizeField: null,
            sizeScale: "linear",

        },

        visualChannels: {
            colorField: {
                name: "data_norm",
                type: "real",
            },
            colorScale: "quantize",
            strokeColorField: null,
            strokeColorScale: "quantize",
            sizeField: null,
            sizeScale: "linear",
        },
    }
}

export const pointCO2Animated = {
    id: "fvmyfyq",
    type: "point",
    config: {
        dataId: "CO2",
        label: "CO2",
        color: [142, 207, 86],
        highlightColor: [252, 242, 26, 255],
        columns: {
            lat: "lat",
            lng: "lon",
            altitude: null,
        },
        isVisible: true,
        visConfig: {
            radius: 20,
            fixedRadius: false,
            opacity: 0,
            outline: false,
            thickness: 2,
            strokeColor: null,
            colorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#5A1846",
                    "#900C3F",
                    "#C70039",
                    "#E3611C",
                    "#F1920E",
                    "#FFC300",
                ],
            },
            strokeColorRange: {
                name: "Global Warming",
                type: "sequential",
                category: "Uber",
                colors: [
                    "#5A1846",
                    "#900C3F",
                    "#C70039",
                    "#E3611C",
                    "#F1920E",
                    "#FFC300",
                ],
            },
            radiusRange: [0, 50],
            filled: true,
        },
        hidden: false,
        textLabel: [
            {
                field: null,
                color: [255, 255, 255],
                size: 18,
                offset: [0, 0],
                anchor: "start",
                alignment: "center",
            },
        ],
    },
    visualChannels: {
        colorField: null,
        colorScale: "quantile",
        strokeColorField: null,
        strokeColorScale: "quantile",
        sizeField: null,
        sizeScale: "linear",
    },
};


